import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data));
  }, []);

  return (
    <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-16">
      <p className="overline text-emerald-800 mb-2">Browse by</p>
      <h1 className="font-display text-4xl md:text-5xl font-black text-slate-900 tracking-tight">
        Every category. Every SKU.
      </h1>
      <p className="mt-4 text-slate-600 max-w-2xl">
        Curated ranges from our certified distributor network — updated weekly.
      </p>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cats.map((c) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            data-testid={`categories-link-${c.slug}`}
            className="group relative overflow-hidden border border-slate-200 hover:border-emerald-900/40 rounded-sm bg-white"
          >
            <div className="aspect-[16/10] relative">
              <img src={c.image_url} alt={c.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/85 via-slate-900/25 to-transparent" />
            </div>
            <div className="p-5 -mt-16 relative">
              <p className="overline text-emerald-300">{c.slug}</p>
              <p className="font-display font-bold text-xl text-white mt-1">{c.name}</p>
              <p className="mt-14 text-sm text-slate-600 line-clamp-2">{c.description}</p>
              <div className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-slate-900 group-hover:text-emerald-900">
                Shop category <ArrowUpRight className="w-4 h-4" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
